export default __webpack_public_path__ + "static/media/lem_uni.3a2b7004.png";